import { render, staticRenderFns } from "./AppNavigationMenu.vue?vue&type=template&id=0a3654fe"
import script from "./AppNavigationMenu.vue?vue&type=script&lang=js"
export * from "./AppNavigationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports